<div
  class="editable"
  *ngIf="!editing"
  (click)="edit()"
  (focus)="edit()"
  tabindex="0"
  [ngClass]="{ readonly: readonly }"
  [matTooltip]="showTip"
  [class.locked]="fieldDef.locked"
>
  <div *ngIf="isNestedField; else text">
    <div *ngFor="let item of value; let last = last">{{ displayValue(item.label) }}<span *ngIf="!last">, </span></div>
  </div>

  <ng-template #text>
    {{ displayValue(value) }}
  </ng-template>
</div>
<ng-container *ngIf="editing">
  <select
    [(ngModel)]="value"
    (blur)="onBlur($event)"
    [disabled]="!editing"
    (change)="onSelectionChange($event)"
    class="dropdown-menu-wrapper"
    tabindex="0"
    [disabled]="isDisabled"
  >
    <option *ngFor="let option of options" [value]="option.id">{{ option.value }}</option>
  </select>
</ng-container>
